import Avatar from "@/assets/avatar.png";
import { AvatarDropdown, AvatarName, Notice } from "@/components";
import { getUserInfo } from "@/services/api/login";
import { store } from "@/store";
import type { Settings as LayoutSettings } from "@ant-design/pro-components";
import "@ant-design/v5-patch-for-react-19";
import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
import { history } from "@umijs/max";
import type { ReactNode } from "react";
import { Provider } from "react-redux";
import defaultSettings from "../config/defaultSettings";
import { errorConfig } from "./requestErrorConfig";

const isDev = process.env.NODE_ENV === "development";
const loginPath = "/user/login";

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const userType = localStorage.getItem("userRole");
      return {"isEnterprise":userType === "admin","isPersonal":userType === "bid"}
/*      const id = localStorage.getItem("userId");
      if (id) {
        const res = await getUserInfo(id);
        return res.data;
      }*/
    } catch (error) {
      history.push(loginPath);
    }
    return  {"isEnterprise":false,"isPersonal":true};
  };
  // 如果不是登录页面，执行
  const { location } = history;

  if (
    ![loginPath, "/user/register", "/user/register-result"].includes(
      location.pathname
    )
  ) {
    const currentUser = await fetchUserInfo();
    // 如果已登录且当前页面是login，跳转到/home
    if (localStorage.getItem("token") && location.pathname === loginPath && currentUser.isEnterprise) {
      history.push("/home");
    }
    if (localStorage.getItem("token") && (location.pathname === "/home"||location.pathname === loginPath) && currentUser.isEnterprise) {
      history.push("/users");
    }
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  console.log(initialState);

  return {
    actionsRender: () => [<Notice key="lang" />],
    avatarProps: {
      // src: "https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png",
      src: Avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      // content: localStorage.getItem("user") || "用户",
    },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!localStorage.getItem("token") && location.pathname !== loginPath) {
        history.push(loginPath);
      }
      // 如果已登录且当前页面是login，跳转到/home
      if (localStorage.getItem("token") && location.pathname === loginPath && localStorage.getItem("userRole")==="bid") {
        history.push("/home");
      }
      if (localStorage.getItem("token") && (location.pathname === "/home"|| location.pathname === loginPath ) && localStorage.getItem("userRole")==="admin") {
        history.push("/users");
      }
    },
    bgLayoutImgList: [
      // {
      //   src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
      //   left: 85,
      //   bottom: 100,
      //   height: '303px',
      // },
    ],

    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return <>{children}</>;
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  baseURL: isDev ? "" : "https://proapi.azurewebsites.net",
  ...errorConfig,
};

export function rootContainer(container: ReactNode) {
  return <Provider store={store}>{container}</Provider>;
}
